<template>
  <div class="flex items-center">
    <div class="color-box flex-shrink-0">
      <feather-icon :icon="icon" svgClasses="w-4 h-4"></feather-icon>
    </div>
    <vs-col vs-w="5" class="mx-4">
      <slot></slot>
    </vs-col>
    <vs-col>
      <div class="flex items-center">
        <slot name="result"></slot>
      </div>
    </vs-col>
    <div class="ml-2">
      <vs-button type="flat" icon="icon-x" icon-pack="feather" @click="$emit('onDelete')"></vs-button>
      <!-- <feather-icon icon="XIcon" svgClasses="w-4 h-4"></feather-icon> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ["icon"],
};
</script>

<style lang="scss" scoped>
.color-box {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background-color: rgba(var(--vs-primary)) !important;
  box-shadow: 0px 15px 40px -10px rgba(var(--vs-primary), 0.9);

  display: flex;
  align-items: center;
  justify-content: center;

  color: white;
}
</style>
